import React from 'react';
import { links } from '../data/site';
export function Hero() {
  return <section id="top" className="border-b border-rule" data-id="element-51" data-mp="ejwknco0ih7u">
      <div className="max-w-content mx-auto px-6 lg:px-10 pt-16 pb-20 md:pt-24 md:pb-28" data-id="element-52" data-mp="eiboxjpyos8e">
        <div className="grid lg:grid-cols-12 gap-y-12 lg:gap-x-16" data-id="element-53" data-mp="9llat1xpw6pm">
          <div className="lg:col-span-8" data-id="element-54" data-mp="4m8m0bnacpke">
            <p className="text-xs sm:text-[0.8125rem] uppercase tracking-[0.14em] text-clay font-medium" data-id="element-55" data-mp="4n9wadwh9812">
              Fractional Transformation Executive
            </p>

            <h1 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.1] tracking-tight text-ink" data-id="element-56" data-mp="xbfk59itvd54">
              When something important is stuck, unclear, or changing, I help find the real
              constraint and lead the work to fix it.
            </h1>

            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-57" data-mp="3d21v45faeyrf">
              I work alongside founders, executive directors, and leadership teams on 2–6 month,
              part-time engagements involving strategy-to-execution, leadership transitions,
              operating systems, and applied AI.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-7" data-id="element-58" data-mp="3o73pmcpadw8l">
              <a href={links.booking} target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center text-base font-medium text-paper bg-ink px-7 py-3.5 rounded-md hover:bg-clay transition-colors duration-200" data-id="element-59" data-mp="399tex5kgwudx">
                Let’s Talk
              </a>
              <a href="#how-i-work" className="inline-flex justify-center items-center text-base text-ink-soft hover:text-ink border-b border-rule hover:border-clay pb-0.5 transition-colors duration-200" data-id="element-60" data-mp="2qkdaw89kqjsr">
                How I Work
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 lg:pl-10 lg:border-l lg:border-rule flex lg:items-end" data-id="element-61" data-mp="2ljh0rcymq1ew">
            <div className="max-w-sm" data-id="element-62" data-mp="s2tdhljfo9pq">
              <p className="font-serif text-xl md:text-[1.375rem] leading-snug text-ink" data-id="element-63" data-mp="s3usu27hfid9">
                Find the constraint. Fix it fast. Leave the organization stronger.
              </p>
              <p className="mt-5 text-base leading-relaxed text-ink-mute" data-id="element-64" data-mp="ia5f4mct1xow">
                Based in Portland, Oregon.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}